import { arrayOf, shape, string } from 'prop-types';

const propTypes = arrayOf(
  shape({
    /** Name of the group */
    name: string.isRequired,
    /** Collection of topics in the group */
    topics: arrayOf(
      shape({
        /** slug for this topic, used in URLS */
        slug: string.isRequired,
        /** Name of the topic, used as title */
        name: string.isRequired,
        /** String containing Github flavored Markdown to be displayed as contents for this glossary term */
        content: string,
      })
    ).isRequired,
  })
);

export default propTypes;
